import { Typography, Divider } from "@mui/material";
import { Link } from "react-router-dom";
import { useTheme } from "@emotion/react";

const RefundPolicy = () => {
  const theme = useTheme();
  return (
    <div style={{ padding: "50px 80px" }}>
      <Typography variant="h4">Refund Policy</Typography>
      <br />
      <Divider />
      <br />
      <Typography variant="body1" paragraph>
        Thank you for choosing our subscription service. We appreciate your
        business and want to ensure you have a clear understanding of our refund
        policy. Please read the following carefully before making a purchase.
      </Typography>

      <Typography variant="h6" gutterBottom>
        Subscription Refund Policy
      </Typography>

      <Typography variant="body1" paragraph>
        Once a subscription is purchased, it becomes non-refundable. We
        understand that circumstances may change, and to accommodate that, we
        offer flexibility through subscription cancellation for the next billing
        cycle.
      </Typography>

      <Typography variant="body1" paragraph>
        To cancel your subscription for the next billing cycle, please follow
        these steps:
      </Typography>

      <ol>
        <li>
          <Typography variant="body1" paragraph>
            Navigate to your account section.
          </Typography>
        </li>
        <li>
          <Typography variant="body1" paragraph>
            Click on "Cancel Subscription."
          </Typography>
        </li>
      </ol>

      <Typography variant="body1" paragraph>
        Please be aware that canceling your subscription prevents automatic
        renewal for the following month. However, it does not provide a refund
        for the current billing cycle, which remains active until the end of the
        subscribed period.
      </Typography>

      <Typography variant="body1" paragraph>
        If you have any questions or concerns regarding our refund policy, we
        encourage you to reach out to us through our{" "}
        <Link
          to="/contact-us"
          color="primary"
          underline="always"
          style={{ color: `${theme.palette.primary.main}`, fontWeight: 500 }}
        >
          contact page
        </Link>
        . Our customer support team is ready to assist you.
      </Typography>
    </div>
  );
};

export default RefundPolicy;
